export default {
  camara: 'Câmara dos Deputados',
  senado: 'Senado Federal',
  almg: 'ALMG',
  alesp: 'ALESP',
  aleac: 'ALEAC',
  aleal: 'ALEAL',
  aleam: 'ALEAM',
  alero: 'ALERO',
  alepi: 'ALEPI',
  alepe: 'ALEPE',
  aleto: 'ALETO',
  alerr: 'ALERR',
} as Record<string, string>
